import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useCurrentUser } from '@bonusly/who-am-i';

export const AdminRoute: FC<PropsWithChildren> = ({ children }) => {
	const user = useCurrentUser();

	const isAdmin =
		user?.admin ||
		user?.finance_admin ||
		user?.global_admin ||
		user?.rewards_admin ||
		user?.tech_admin ||
		user?.awards_admin ||
		user?.announcements_admin ||
		user?.reports_admin ||
		user?.tech_ops_admin ||
		user?.super_admin;

	if (isAdmin) {
		return <>{children}</>;
	}

	return <Navigate to="/404" replace />;
};
